import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

export function CourseCardSkeleton() {
  return (
    <Card className="overflow-hidden rounded-2xl border border-border shadow bg-card">
      <CardContent className="p-0">
        <Skeleton className="aspect-square w-full" />
        <div className="p-4">
          <Skeleton className="h-10 w-full rounded-lg" />
        </div>
      </CardContent>
    </Card>
  )
}

